import { Doc } from 'tiptap'

export default class MultiLineDoc extends Doc {
  get schema() {
    return {
      content: 'multiLineEditable',
    }
  }
}
